export default __webpack_public_path__ + "static/media/GiluLive.7e14f4a2.jpeg";